import { useCallback } from "react";
import { useQuery } from "./useQuery";
import { MOCK_SECTION_STATUS } from "../pages/Accounting/Overview/overviewMockData";
import type { SectionStatus } from "../pages/Accounting/Overview/overviewTypes";
import type { QueryResult } from "./types";

/**
 * Status summary for each operational Accounting sub-page.
 * Default: populated. ?populated=0 flips to empty.
 */
export function useSectionStatus(): QueryResult<SectionStatus> {
  const query = useQuery();
  const populated = query.get("populated") !== "0";
  const data: SectionStatus = populated
    ? MOCK_SECTION_STATUS
    : {
        transactions: { importedThisMonth: 0, needReview: 0 },
        receipts:     { matchedThisMonth: 0,  missing: 0 },
        reconcile:    { lastDoneDate: null,   accountsOverdue: 0 },
        accountant:   { inviteeName: null,    invitedDate: null, state: "none" },
      };

  const refetch = useCallback(() => {}, []);
  return { data, loading: false, error: null, refetch };
}